// extracted by mini-css-extract-plugin
export default {"accordionMui":"TextFlex_accordionMui__EXpxG"};